import * as React from 'react';
import { Formatters, Messages } from '../../codegen/Localize';

export interface CharacterCounterProps {
  readonly value: string;
  readonly maximum: number;
  readonly style?: React.CSSProperties;
}

export function CharacterCounter(props: CharacterCounterProps): JSX.Element {
  return <div style={props.style}>
    {
      Messages.characterCounter({
        COUNT_LOC: Formatters.formatCount(props.value.length),
        MAXIMUM_LOC: Formatters.formatCount(props.maximum)
      })
    }
  </div>;
}
